import '../scss/components/_addbedmodal.scss'
import React, { useState, useEffect } from 'react'
import { bedmaster_Insert, roommaster_SelectByPGID } from '../apis/services/pgApi'

// ─── Options ───────────────────────────────────────────────
const yesNoOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
]

const washroomOptions = [
  { value: "Attached", label: "Attached" },
  { value: "Common", label: "Common" },
  { value: "No", label: "No" },
]

const furnitureOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  { value: "Provided", label: "Provided" },
]

const coolingOptions = [
  { value: "AC", label: "AC" },
  { value: "Cooler", label: "Cooler" },
  { value: "Fan", label: "Fan" },
  { value: "None", label: "None" },
]

const windowOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  { value: "Corner", label: "Corner" },
]

const washingMachineOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  { value: "Common", label: "Common" },
]

const statusOptions = [
  { value: "AVAILABLE", label: "Available" },
  { value: "BOOKED", label: "Booked" },
  { value: "OCCUPIED", label: "Occupied" },
  { value: "MAINTENANCE", label: "Maintenance" },
]

// ─── AddBedModal Component ─────────────────────────────────
const AddBedModal = ({ isOpen, onClose, selectedPG, onBedAdded }) => {
  const [form, setForm] = useState({
    RoomID: '',
    BedNumber: '',
    PGTenantRangePerDay: '',
    PGTenantRangePerMonth: '',
    PGRangePerDay: '',
    PGRangePerMonth: '',
    AttachWashRoom: '',
    Balcony: '',
    Furniture: '',
    CoolingType: '',
    Gieser: '',
    WashingMachine: '',
    Induction: '',
    WindowSide: '',
    Status: 'AVAILABLE'
  })
  const [rooms, setRooms] = useState([])
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [loadingRooms, setLoadingRooms] = useState(false)
  const [apiError, setApiError] = useState(null)

   // Fetch rooms on mount
  useEffect(() => {
    if (isOpen) {
      fetchRooms()
    }
  }, [isOpen])

  if (!isOpen) return null

 

  const fetchRooms = async () => {
    setLoadingRooms(true)
    try {
      const data = await roommaster_SelectByPGID(selectedPG?.PGID)
      if (data && data.length > 0) {
        // const transformedRooms = data.map(room => ({
        //   RoomID: room.RoomID,
        //   RoomNumber: room.RoomNumber,
        //   Floor: room.Floor,
        //   Capacity: room.Capacity,
        //   RoomType: room.RoomType,
        // }))
        setRooms(data)
      }
    } catch (error) {
      console.error("Error fetching rooms:", error)
      setApiError("Failed to load rooms")
    } finally {
      setLoadingRooms(false)
    }
  }

  const set = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }))
    setErrors(prev => ({ ...prev, [field]: undefined }))
  }

  const reset = () => {
    setForm({
      RoomID: '',
      BedNumber: '',
      PGTenantRangePerDay: '',
      PGTenantRangePerMonth: '',
      PGRangePerDay: '',
      PGRangePerMonth: '',
      AttachWashRoom: '',
      Balcony: '',
      Furniture: '',
      CoolingType: '',
      Gieser: '',
      WashingMachine: '',
      Induction: '',
      WindowSide: '',
      Status: 'AVAILABLE'
    })
    setErrors({})
    setApiError(null)
  }

  const handleClose = () => {
    reset()
    onClose()
  }

  const validate = () => {
    const e = {}
    if (!form.RoomID) e.RoomID = 'Please select a room'
    if (!form.BedNumber.trim()) e.BedNumber = 'Bed number is required'
    return e
  }

  const handleSubmit = async () => {
    const validationErrors = validate()
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors)
      return
    }

    setLoading(true)
    setApiError(null)

    try {
      // Get user ID from localStorage
      const userId = localStorage.getItem('userId')

      // Prepare bed data
      const bedData = {
        RoomID: parseInt(form.RoomID),
        BedNumber: form.BedNumber,
        PGTenantRangePerDay: form.PGTenantRangePerDay || null,
        PGTenantRangePerMonth: form.PGTenantRangePerMonth || null,
        PGRangePerDay: form.PGRangePerDay ? parseFloat(form.PGRangePerDay) : null,
        PGRangePerMonth: form.PGRangePerMonth ? parseFloat(form.PGRangePerMonth) : null,
        AttachWashRoom: form.AttachWashRoom || null,
        Balcony: form.Balcony || null,
        Furniture: form.Furniture || null,
        CoolingType: form.CoolingType || null,
        Gieser: form.Gieser || null,
        WashingMachine: form.WashingMachine || null,
        Induction: form.Induction || null,
        WindowSide: form.WindowSide || null,
        Status: form.Status,
        // nUserId: userId ? parseInt(userId) : null
      }

      console.log("Sending bed data:", bedData)

      const response = await bedmaster_Insert(bedData)

      if (response && (response.Success === 1 || response.statusCode === 201 || response.Message?.includes('success'))) {
        if (onBedAdded) {
          onBedAdded({
            ...form,
            id: response.BedID || response.data?.bedId,
            submittedAt: new Date().toISOString()
          })
        }

        reset()
        onClose()
        
        alert(response.Message || 'Bed added successfully!')
      } else {
        throw new Error(response?.Message || 'Failed to add bed')
      }

    } catch (error) {
      console.error('Error adding bed:', error)
      setApiError(error.message || 'Failed to add bed. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  const getSelectedRoomInfo = () => {
    if (!form.RoomID) return null
    return rooms.find(r => r.RoomID === parseInt(form.RoomID))
  }

  const selectedRoom = getSelectedRoomInfo()

  return (
    <div className="abm-overlay" >
      <div className="abm-modal" onClick={e => e.stopPropagation()}>
        
        {/* Header */}
        <div className="abm-head">
          <div>
            <h2 className="abm-title">Add New Bed</h2>
            {selectedPG && (
              <p className="abm-sub">
                PG: <strong>{selectedPG.PGName}</strong>
              </p>
            )}
          </div>
          <button className="abm-close" onClick={handleClose}>
            <svg width="15" height="15" viewBox="0 0 18 18" fill="none">
              <path d="M1 1L17 17M17 1L1 17" stroke="#374151" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        {/* API Error Display */}
        {apiError && (
          <div className="abm-error-box">
            <strong>Error:</strong> {apiError}
          </div>
        )}

        {/* Form Body */}
        <div className="abm-form-body">
          
          {/* Basic Information Section */}
          <div className="abm-section">
            <h4 className="abm-section-title">Basic Information</h4>
            <div className="abm-grid">
              
              <div className={`abm-field ${errors.RoomID ? 'abm-field-err' : ''}`}>
                <label className="abm-label">Select Room <span className="abm-req">*</span></label>
                <select 
                  className="abm-select" 
                  value={form.RoomID} 
                  onChange={e => set('RoomID', e.target.value)}
                  disabled={loadingRooms}
                >
                  <option value="">{loadingRooms ? "Loading rooms..." : "Select room"}</option>
                  {rooms.map(room => (
                    <option key={room.RoomID} value={room.RoomID}>
                      {room.Room}
                    </option>
                  ))}
                </select>
                {errors.RoomID && <span className="abm-err-msg">{errors.RoomID}</span>}
                {selectedRoom && (
                  <p className="abm-hint">
                    Selected room has capacity for {selectedRoom.Capacity} beds
                  </p>
                )}
              </div>
              
              <div className={`abm-field ${errors.BedNumber ? 'abm-field-err' : ''}`}>
                <label className="abm-label">Bed Number <span className="abm-req">*</span></label>
                <input 
                  className="abm-input" 
                  placeholder="e.g. B101, BED-01" 
                  value={form.BedNumber} 
                  onChange={e => set('BedNumber', e.target.value)} 
                />
                {errors.BedNumber && <span className="abm-err-msg">{errors.BedNumber}</span>}
              </div>
              
              <div className="abm-field">
                <label className="abm-label">Status</label>
                <select 
                  className="abm-select" 
                  value={form.Status} 
                  onChange={e => set('Status', e.target.value)}
                  disabled={true}
                >
                  {statusOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              
            </div>
          </div>

          {/* Pricing Information Section */}
          <div className="abm-section">
            <h4 className="abm-section-title">Pricing Information</h4>
            <div className="abm-grid">
              
              <div className="abm-field">
                <label className="abm-label">PG Tenant Range (Per Day)</label>
                <input 
                  className="abm-input" 
                  placeholder="e.g. 300-500" 
                  value={form.PGTenantRangePerDay} 
                  onChange={e => set('PGTenantRangePerDay', e.target.value)} 
                />
              </div>
              
              <div className="abm-field">
                <label className="abm-label">PG Tenant Range (Per Month)</label>
                <input 
                  className="abm-input" 
                  placeholder="e.g. 8000-10000" 
                  value={form.PGTenantRangePerMonth} 
                  onChange={e => set('PGTenantRangePerMonth', e.target.value)} 
                />
              </div>
              
              <div className="abm-field">
                <label className="abm-label">PG Range (Per Day) - ₹</label>
                <input 
                  className="abm-input" 
                  type="number" 
                  placeholder="0" 
                  value={form.PGRangePerDay} 
                  onChange={e => set('PGRangePerDay', e.target.value)} 
                />
              </div>
              
              <div className="abm-field">
                <label className="abm-label">PG Range (Per Month) - ₹</label>
                <input 
                  className="abm-input" 
                  type="number" 
                  placeholder="0" 
                  value={form.PGRangePerMonth} 
                  onChange={e => set('PGRangePerMonth', e.target.value)} 
                />
              </div>
              
            </div>
          </div>

          {/* Amenities & Features Section */}
          <div className="abm-section">
            <h4 className="abm-section-title">Amenities & Features</h4>
            <div className="abm-grid">
              
              <div className="abm-field">
                <label className="abm-label">Attached Washroom</label>
                <select 
                  className="abm-select" 
                  value={form.AttachWashRoom} 
                  onChange={e => set('AttachWashRoom', e.target.value)}
                >
                  <option value="">Select</option>
                  {washroomOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              
              <div className="abm-field">
                <label className="abm-label">Balcony</label>
                <select 
                  className="abm-select" 
                  value={form.Balcony} 
                  onChange={e => set('Balcony', e.target.value)}
                >
                  <option value="">Select</option>
                  {yesNoOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              
              <div className="abm-field">
                <label className="abm-label">Furniture</label>
                <select 
                  className="abm-select" 
                  value={form.Furniture} 
                  onChange={e => set('Furniture', e.target.value)}
                >
                  <option value="">Select</option>
                  {furnitureOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              
              <div className="abm-field">
                <label className="abm-label">Cooling Type</label>
                <select 
                  className="abm-select" 
                  value={form.CoolingType} 
                  onChange={e => set('CoolingType', e.target.value)}
                >
                  <option value="">Select</option>
                  {coolingOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              
              <div className="abm-field">
                <label className="abm-label">Geyser</label>
                <select 
                  className="abm-select" 
                  value={form.Gieser} 
                  onChange={e => set('Gieser', e.target.value)}
                >
                  <option value="">Select</option>
                  {yesNoOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              
              <div className="abm-field">
                <label className="abm-label">Washing Machine</label>
                <select 
                  className="abm-select" 
                  value={form.WashingMachine} 
                  onChange={e => set('WashingMachine', e.target.value)}
                >
                  <option value="">Select</option>
                  {washingMachineOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              
              <div className="abm-field">
                <label className="abm-label">Induction</label>
                <select 
                  className="abm-select" 
                  value={form.Induction} 
                  onChange={e => set('Induction', e.target.value)}
                >
                  <option value="">Select</option>
                  {yesNoOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              
              <div className="abm-field">
                <label className="abm-label">Window Side</label>
                <select 
                  className="abm-select" 
                  value={form.WindowSide} 
                  onChange={e => set('WindowSide', e.target.value)}
                >
                  <option value="">Select</option>
                  {windowOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              
            </div>
          </div>

        </div>

        {/* Footer */}
        <div className="abm-footer">
          <button className="abm-btn abm-btn-outline" onClick={handleClose} disabled={loading}>
            Cancel
          </button>
          <button className="abm-btn abm-btn-primary" onClick={handleSubmit} disabled={loading}>
            {loading ? (
              <>
                <span className="abm-spinner"></span>
                Adding Bed...
              </>
            ) : (
              <>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 6L5 9L10 3" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                </svg>
                Add Bed
              </>
            )}
          </button>
        </div>

      </div>

      <style>{`
        .abm-spinner {
          display: inline-block;
          width: 12px;
          height: 12px;
          border: 2px solid #fff;
          border-top-color: transparent;
          border-radius: 50%;
          animation: abm-spin 0.6s linear infinite;
          margin-right: 8px;
        }
        
        @keyframes abm-spin {
          to {
            transform: rotate(360deg);
          }
        }
        
        .abm-error-box {
          margin: 16px 24px;
          padding: 12px;
          background: #FEF2F2;
          border: 1px solid #FEE2E2;
          border-radius: 8px;
          color: #DC2626;
          font-size: 13px;
        }
        
        .abm-hint {
          font-size: 11px;
          color: #6B7280;
          margin-top: 4px;
        }
      `}</style>
    </div>
  )
}

export default AddBedModal